
export default {
    name: 'LeePasswordInput',
    inheritAttrs: false,
    data() {
        return {
            password: [],
            isshow: false,
            tips: '',
            ge: [1, 1, 1, 1, 1, 1],
            code: ''
        };
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        pass: {
            type: String,
            default: '123456'
        }
    },
    methods: {
        ws(e) {
            var n = e.target.innerText;
            if (this.password.length >= 6) {
                return
            } else {
                this.password.push(n)
            }

        },
        del() {
            this.tips = ""
            if (this.code == '') {
                this.password.pop()
                this.code = ''
            } else {
                this.password = []
                this.code = ''
            }

        },
        close() {
            this.$emit('input', false)
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.isshow=value
            }
        },
        password: {
            immediate: true,
            handler(value) {
                value = value.join("");
                if (value.length == 6) {
                    if (value != this.pass) {
                        this.tips = "密码错误"
                        this.code = '-1'
                    } else {
                        this.tips = "密码正确"
                        this.code = '1'
                    }
                    this.$emit('change', this.code)
                }
            }
        }
    },
    computed: {
        myclass(){
            if(this.code==-1){
                return 'err'
            }else if(this.code==1){
                return 'ok'
            }else{
                return ''
            }
        }

    }
};
